import { render, staticRenderFns } from "./MessageHub.vue?vue&type=template&id=54e526ae&scoped=true"
import script from "./MessageHub.vue?vue&type=script&lang=js"
export * from "./MessageHub.vue?vue&type=script&lang=js"
import style0 from "./MessageHub.vue?vue&type=style&index=0&id=54e526ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e526ae",
  null
  
)

export default component.exports